import React from 'react';
import { Cushion, Typography } from '@pitchero/react-ui';
import { Trans } from '../../lib/i18n';

const LoadingFailedState = () => (
  <Cushion vertical="medium">
    <Typography preset="body--large" component="div" align="center">
      <Trans i18nKey="common:comments_load_failure">Failed to load comments</Trans>
    </Typography>
  </Cushion>
);

export default LoadingFailedState;
